<template>
  <v-radio-group
    v-model="valueOpcaoSelecionadaIdLocale"
    class="my-0 mr-1 pt-0"
    hide-details
    :mandatory="obrigatorio && !readonly "
    :label="label"
    :filled="filled"
    :disabled="disabled"
    :readonly="readonly"
    @change="$emit('input-changed', { value: $event })"
  >
    <template
      v-if="mostrarIcones"
      v-slot:prepend
    >
      <icons
        :is-configurar-celula-dialog-open="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open="isDeletarComponenteDialogOpen"
        :vertical="true"
        @update:is-configurar-celula-dialog-open="v => $emit('update:is-configurar-celula-dialog-open', v)"
        @update:is-deletar-componente-dialog-open="v => $emit('update:is-deletar-componente-dialog-open', v)"
      />
    </template>

    <v-radio
      v-for="(item, index) in opcoes"
      :key="index"
      :label="item.nome"
      :value="item.id"
    />
  </v-radio-group>
</template>

<script>
import { ref, watchEffect } from '@vue/composition-api'
import ComponenteBase from './ComponenteBase.vue'
import Icons from './Icons.vue'
import selectableComponentMixin from '@/mixins/selectableComponentMixin'

export default {
  components: {
    Icons,
  },

  extends: ComponenteBase,

  mixins: [selectableComponentMixin],

  setup(props) {
    const valueOpcaoSelecionadaIdLocale = ref(null)
    watchEffect(() => { valueOpcaoSelecionadaIdLocale.value = props.valueOpcaoSelecionadaId })

    return {
      valueOpcaoSelecionadaIdLocale,
    }
  },
}
</script>
